export default __webpack_public_path__ + "static/media/TEG.4d84f351.jpg";